import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import parse from 'html-react-parser';

import Container from '../../containers/Container';
import Button from '../../components/Button';
import Grid from '../../components/Grid';
import PdfLoader from '../../utils/PdfLoader';
import styles from './styles';

import { ReactComponent as HexaSvg6 } from '../../res/hexa6.svg';
import { ReactComponent as HexaSvg7 } from '../../res/hexa7.svg';

class FichesActionsTransversales extends React.Component {
  render() {
    const { classes, data } = this.props;
    const { 'actions-transversales': block } = data.fiches;
    return (
      <Container id="fiches-actions-transversales" className={classes.container} zIndex={6}>
        <HexaSvg6 className={classes.hexaSvg6} />
        <div className={classes.hexaSvg7Container}>
          <HexaSvg7 className={classes.hexaSvg7} />
        </div>
        <div className={classes.titleContainer}>
          <Typography className={classes.title} variant="h1">
            {parse(block.title)}
          </Typography>
        </div>
        <Grid lg={3} md={4} sm={6} xs={12} className={classes.ficheGrid}>
          {block.fiches.map((fiche, idx) => (
            <div key={idx} className={classes.ficheContainer}>
              <Typography variant="h5" className={classes.ficheNum}>
                {parse(fiche.num)}
              </Typography>
              <Typography variant="h5" className={classes.ficheTitle}>
                {parse(fiche.title)}
              </Typography>
              <Button color="yellow2" size="small" onClick={PdfLoader(fiche.pdf)}>
                {parse(block['button-read'])}
              </Button>
            </div>
          ))}
        </Grid>
      </Container>
    );
  }
}

FichesActionsTransversales.propTypes = {
  data: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(FichesActionsTransversales);
